import { computed, Ref } from 'vue';
import { FilterKey } from '@studyportals/search-filters/server-side';
import { disciplineGetVirtualPath } from '@studyportals/static-domain-data/disciplines/discipline-get-virtual-path';
import store from '@/store';
import { FacetValues } from '@studyportals/search-api-interface';
import { disciplinesAll } from '@studyportals/static-domain-data/disciplines/disciplines';
import PathUtils from '@/utils/PathUtils';
import { EventAggregationService } from '@/utils/EventAggregationService';
import { SearchPageRefreshText } from '@studyportals/search-page-interface';
export default class Discipline {
	constructor(public readonly discipline: Ref<FacetValues>) {}
	public virtualPath = computed((): string | null =>
		disciplineGetVirtualPath(this.discipline.value.value)
	);
	public amount = computed((): string => {
		const amount = this.disciplineFacetValue.value?.count;
		if (!amount) return "0";

		if (amount >= 1000) {
			return `${(amount / 1000).toFixed(1)}k`;
		}

		return amount.toString();
	});

	public disciplineFacetValue = computed((): FacetValues | undefined =>
		store.getters
			.getFacets(FilterKey.DISCIPLINES)
			.find((f) => f.value === this.discipline.value.value)
	);
	disciplineProps = computed(() =>
		disciplinesAll.find((ds) => ds.id === this.discipline.value.value)
	);
	public onDisciplineClick = async (): Promise<void> => {
		EventAggregationService.instance?.publishTo(
			SearchPageRefreshText.EventType,
			new SearchPageRefreshText('')
		);
		if (!this.isSearchPage.value) {
			window.location.href = this.path.value;
			return;
		}
		if (this.isUniversitySearch.value) {
			window.location.href = this.universityPath.value;
			return;
		}
		if(this.isScholarshipSearch.value){
			window.location.href = this.scholarshipsPath.value;
			return;
		}
		await store.actions.setDisciplineAsFilter(this.discipline.value);
	};
	isUniversitySearch = computed((): boolean => PathUtils.IsUniversitySearch());
	isScholarshipSearch = computed((): boolean =>
		PathUtils.isScholarshipSearch()
	);
	isSearchPage = computed((): boolean => PathUtils.isInSearchPage());

	universityPath = computed(
		(): string =>
			`/search/universities/${this.portalPathFragment.value}?di=${this.discipline.value.value}`
	);
	scholarshipsPath = computed(
		(): string =>
			`/search/scholarships/${this.portalPathFragment.value}/${this.virtualPath.value}`
	);

	public path = computed(
		(): string =>
			`/search/${this.portalPathFragment.value}/${this.virtualPath.value}`
	);
	portalPathFragment = computed((): string => PathUtils.portalPathFragment());
}